'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StickerComponent } from './component';

@NgModule({
  imports     : [
    BrowserModule
  ],
  declarations: [StickerComponent],
  exports     : [StickerComponent]
})
export class LKSticker {
}
